import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconWeather$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconWeather extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '074f02294b4fe975cca28610b32656541808f993', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cdde943411b45a801a869435e0b1cbef1baeabe2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9ab2ee985f0afea186b2df8cc8d5f7bdbd5a5622', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.25 3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zM21 10.25a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5zm-1.873-4.316a.5.5 0 0 0 0-.707l-.354-.354a.5.5 0 0 0-.707 0l-.707.708a.5.5 0 0 0 0 .707l.354.353a.5.5 0 0 0 .707 0zm-9.9-1.06a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707l-.354.353a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707zm8.132 8.838a.5.5 0 0 0 0 .707l.707.707a.5.5 0 0 0 .707 0l.354-.353a.5.5 0 0 0 0-.707l-.707-.708a.5.5 0 0 0-.707 0zm-6.187-6.54a4 4 0 0 0-.809 1.161c.475.18.918.429 1.317.733a2.5 2.5 0 1 1 3.28 3.243 4 4 0 0 1 .788 1.29 4 4 0 1 0-4.576-6.428m.022 5.352.267.829.852.18A1.501 1.501 0 0 1 12 16.5H3.5a1 1 0 1 1 0-2h2.106l.142-1.342c.164-1.548 1.4-2.658 2.79-2.658 1.193 0 2.265.81 2.656 2.024M8.538 9c-2.217 0-4.043 1.75-4.281 4H3.5a2.5 2.5 0 0 0 0 5H12a3 3 0 0 0 .622-5.935C12.05 10.283 10.437 9 8.538 9", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-weather", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-weather"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-weather":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconWeather$1);
            }
            break;
    } });
}

const CosmosIconWeather = CosmosIconWeather$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconWeather, defineCustomElement };
